import { render, staticRenderFns } from "./AccessoryEventView.vue?vue&type=template&id=96e49d44&scoped=true"
import script from "./AccessoryEventView.vue?vue&type=script&lang=js"
export * from "./AccessoryEventView.vue?vue&type=script&lang=js"
import "./AccessoryEventView.vue?vue&type=style&index=0&id=96e49d44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e49d44",
  null
  
)

export default component.exports